import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { VueFlux, FluxControls, FluxPagination } from "vue-flux";
import { request } from "@/js/http/http_request";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { hasRole, isUserBuyerGroup, isAdminNotConsultant, isHolding, getClientAppData } from "@/js/http/auth.js";
import { imgDbType, buyLimitErrors, listTerms, purchaseOrder } from "@/js/lists.ts";
import * as orderHandler from "@/js/order/order.js";
import { formRules } from "@/js/form_rules.js";
import returnComponent from "@/components/navigation/ReturnToList.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import Map from "@/components/map/Map.vue";
import Address from "@/components/address/Address.vue";
import TargetSelectors from "@/components/order/TargetSelector/TargetSelectors.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import ProducerStorageAddresses from "@/components/producers/ProducerStorageAddresses.vue";
import ProducerAttachedFilesDrawer from "@/components/producers/ProducerAttachedFilesDrawer.vue";
import WineCard from "@/components/products/WineCard.vue";
import WineStockListModal from "@/components/products/WineStockListModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "Producer",
  components: {
    Address: Address,
    WineCard: WineCard,
    return: returnComponent,
    confirm: confirmationComponent,
    VueFlux: VueFlux,
    FluxControls: FluxControls,
    FluxPagination: FluxPagination,
    Map: Map,
    UploaderV2: UploaderV2,
    TargetSelectors: TargetSelectors,
    ProducerStorageAddresses: ProducerStorageAddresses,
    ProducerAttachedFilesDrawer: ProducerAttachedFilesDrawer,
    WineStockListModal: WineStockListModal,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | String,
    loggedUserData: Object,
    isWinery: Boolean,
    isDistillery: Boolean,
    returnRoute: String | null
  },
  data: function data(_this) {
    return {
      clientAppData: null,
      thirdPartyOrder: false,
      isAddingToCart: [],
      vfOptions: {
        autoplay: true
      },
      vfluxDefault: null,
      vfTransitions: ["slide"],
      readOnly: true,
      loading: true,
      getProducerCancellationToken: null,
      isMakingDrawerStateless: false,
      isMainUploaderContainsFile: false,
      listCountries: [],
      listStates: [],
      regions: [],
      producer: {
        id: null,
        logisticEmail: null,
        skuAcronym: null,
        name: null,
        description: null,
        isWinery: false,
        isDistillery: false,
        images: null,
        regionSubs: [],
        address: {
          street: "",
          zip: "",
          city: "",
          state: "",
          country: ""
        },
        alternativeStorageAddresses: [],
        isExcludedWineSearcher: false,
        isDefaultTastingPhotoRequired: false
      },
      dbSupplierAssociated: {
        contactLastname: "",
        contactFirstname: "",
        phone: "",
        terms: 1,
        paymentMethod: null
      },
      productTypeRefs: [{
        id: "wines",
        name: "Wines"
      }, {
        id: "spirits",
        name: "Spirits"
      }],
      productTypes: [],
      gettingImages: {
        isPending: false,
        cancellationToken: null
      },
      producerImages: {
        mainImg: "",
        secondaryImg: []
      },
      gettingProducts: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      addingRegionSub: {
        isOpen: false,
        form: {
          regionSub: {},
          regionParent: {}
        }
      },
      refreshingRegions: {
        isPending: false,
        cancellationToken: null
      },
      checkingSkuAcronymUnicity: {
        isPending: false,
        cancellationToken: null,
        result: null
      },
      initDefaultTastingPhotoRequired: false,
      applyNewDefaultTastingPhotoRequired: true,
      managedExceptions: {
        error: {
          address_deleted_stock_used_in_order: "You tried to delete a storage address, that is linked to a stock used in a cart or an order in progress"
        },
        warning: {
          skuacronym_exists: "The SKU acronym already exists."
        }
      },
      mapFailedLoading: false,
      returnParams: {
        isHistoryBack: false,
        regionSubId: null,
        regionName: "Region",
        routeName: "userRegionDetails",
        params: {
          idRegion: null
        },
        query: null
      },
      addQuantity: 1,
      quantityByWine: [],
      valid: false,
      skuManual: false,
      skuAcronymOriginal: "",
      imagesDrawer: false,
      wineStockKey: null,
      currentWine: null,
      casingIdSelected: null,
      currentQuantity: 0,
      listPaymentMethods: Object.entries(purchaseOrder.paymentMethod).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: +key,
          label: value.text
        }]);
      }, []),
      listTerms: listTerms,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    canManage: function canManage() {
      return isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_PRODUCERS);
    },
    isAdding: function isAdding() {
      var _this$producer;
      return !((_this$producer = this.producer) !== null && _this$producer !== void 0 && _this$producer.id) > 0;
    },
    uploadSecondaryUrl: function uploadSecondaryUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/producers/").concat(this.producer.id, "/images/secondary");
    },
    uploadMainUrl: function uploadMainUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/producers/").concat(this.producer.id, "/images/main");
    },
    producerAddress: function producerAddress() {
      return "".concat(this.producer.address.street, ", ") + "".concat(this.producer.address.city, " ") + "".concat(this.producer.address.zip, ", ") + "".concat(this.producer.address.country.printable_name);
    },
    labelProducer: function labelProducer() {
      if (this.producer.isWinery && this.producer.isDistillery) return "winery & distillery";
      if (this.producer.isWinery) return "winery";
      if (this.producer.isDistillery) return "distillery";
      return "producer";
    },
    isProducerValid: function isProducerValid() {
      return this.valid && this.producer.regionSubs.length > 0 && this.$refs.address.valid && (this.producer.isWinery || this.producer.isDistillery);
    },
    vfluxImages: function vfluxImages() {
      return this.vfluxDefault ? this.vfluxDefault : this.producerImages.secondaryImg;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$$route$query;
      var _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.thirdPartyOrder = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            _this2.clientAppData = getClientAppData(_this2);
            _context.next = 4;
            return orderHandler.refreshCategoryUser(_this2);
          case 4:
            if (_this2.$route.params.id) {
              _this2.producer.id = +_this2.$route.params.id;
            } else if (_this2.$props.id) {
              _this2.producer.id = _this2.$props.id;
            }
            if (!((_this2$$route$query = _this2.$route.query) !== null && _this2$$route$query !== void 0 && _this2$$route$query.idSubRegion)) {
              _this2.returnParams.isHistoryBack = true;
            } else {
              _this2.returnParams.regionSubId = _this2.$route.query.idSubRegion;
            }
            if (isUserBuyerGroup(_this2.loggedUserData)) {
              _this2.returnParams.routeName = "userRegionDetails";
            } else {
              _this2.returnParams.routeName = "adminRegionDetails";
            }
            _this = _this2;
            if (!_this.canManage) {
              _context.next = 11;
              break;
            }
            _context.next = 11;
            return request("/v1/countries", "post", _this.clientAppData, false, "api").then(function (response) {
              _this.listCountries = _toConsumableArray(response.data.countries);
              _this.listStates = _toConsumableArray(response.data.states);
            }).catch(function (e) {
              var errorData = getErrorData(e, _this.managedExceptions);
              handleErrorData(_this, errorData);
            });
          case 11:
            if (_this2.producer.id) {
              _this2.fetchImages();
              _this2.fetchAllProducts();
            }
            _context.next = 14;
            return _this2.getProducer();
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    clickOutsideDrawer: function clickOutsideDrawer() {
      if (this.isMakingDrawerStateless) this.imagesDrawer = true;
    },
    digestStatelessDrawer: function digestStatelessDrawer() {
      var _this = this;
      setTimeout(function () {
        return _this.isMakingDrawerStateless = false;
      }, 1000);
    },
    syncUpload: function syncUpload() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.fetchImages();
            case 2:
              _this3.$EventBus.$emit("loading", false);
              _this3.digestStatelessDrawer();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    uploadSecondaryAcknowledge: function uploadSecondaryAcknowledge() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.fetchImages();
            case 2:
              _this4.$EventBus.$emit("loading", false);
              _this4.digestStatelessDrawer();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getProducer: function getProducer() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$getProducerCanc;
        var url, _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/v1/producers/";
              if (_this5.producer.id && _this5.producer.id > 0) {
                url += _this5.producer.id;
                if (!_this5.canManage) {
                  url += "?excludeLinkedData=true";
                }
              } else {
                if (_this5.isWinery) _this5.producer.isWinery = true;
                if (_this5.isDistillery) _this5.producer.isDistillery = true;
              }
              _this = _this5;
              (_this$getProducerCanc = _this.getProducerCancellationToken) === null || _this$getProducerCanc === void 0 || _this$getProducerCanc.cancel();
              _this.getProducerCancellationToken = axios.CancelToken.source();
              _context4.next = 7;
              return request(url, "get", null, true, "api", null, _this.getProducerCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, null, true);
                  handleErrorData(_this, errorData);
                  _this.loading = false;
                }
                throw e;
              });
            case 7:
              response = _context4.sent;
              if (response.data.value.regions) {
                _this5.regions.splice(response.data.value.regions.length);
                _this5.regions = _toConsumableArray(response.data.value.regions.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    displayName: "".concat(x.country.printable_name, " / ").concat(x.name, " (").concat(x.isSpiritRegion ? "spirits" : "wines", ")")
                  });
                }));
              }
              if (response.data.value.producer) {
                _this5.producer = _objectSpread({}, response.data.value.producer);
                _this5.producer.alternativeStorageAddresses.forEach(function (x) {
                  x.technical_front_id = x.id;
                });
                _this5.skuAcronymOriginal = _this5.producer.skuAcronym;
                _this5.initDefaultTastingPhotoRequired = _this5.producer.isDefaultTastingPhotoRequired;
                _this5.returnParams.query = _objectSpread({}, _this5.$route.query);
              }
              if (response.data.value.dbSupplierAssociated) {
                _this5.dbSupplierAssociated = {
                  contactLastname: response.data.value.dbSupplierAssociated.contactLastname,
                  contactFirstname: response.data.value.dbSupplierAssociated.contactFirstname,
                  phone: response.data.value.dbSupplierAssociated.phone,
                  terms: response.data.value.dbSupplierAssociated.terms,
                  paymentMethod: response.data.value.dbSupplierAssociated.paymentMethod
                };
              }
              _this5.productTypes = [];
              if (_this5.producer.isWinery) _this5.productTypes.push("wines");
              if (_this5.producer.isDistillery) _this5.productTypes.push("spirits");

              // get region name
              if (_this5.returnParams.regionSubId) {
                _this5.returnParams.regionName = _this5.producer.regionSubs.find(function (x) {
                  return x.id === +_this5.returnParams.regionSubId;
                }).regionParent.name;
              }
              _this5.loading = false;
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchAllProducts: function fetchAllProducts() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this$gettingProducts;
        var _this, data, pricePostingSelected, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.gettingProducts.isPending = true;
              _this6.gettingProducts.results = [];
              _this = _this6;
              (_this$gettingProducts = _this.gettingProducts.cancellationToken) === null || _this$gettingProducts === void 0 || _this$gettingProducts.cancel();
              _this.gettingProducts.cancellationToken = axios.CancelToken.source();
              data = {
                isApplyActivePricePostingByDefault: false
              };
              if (_this6.thirdPartyOrder && orderHandler.getThirdPartyUserSelected()) {
                data.userIdTarget = +orderHandler.getThirdPartyUserSelected().id_user;
              }
              pricePostingSelected = orderHandler.getPricePostingUsaSelected();
              if (!!pricePostingSelected) {
                data.pricePostingUsaProId = pricePostingSelected.id;
              }
              paramsQuery = Object.encodeToUri(data);
              _context5.next = 12;
              return request("/v1/producers/".concat(_this.producer.id, "/products?params=").concat(paramsQuery), "get", null, true, "api", null, _this.gettingProducts.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingProducts.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get products.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 12:
              response = _context5.sent;
              _this6.gettingProducts.results = _toConsumableArray(response.data.value);
              _this6.gettingProducts.isPending = false;
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    refreshRegions: function refreshRegions() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$refreshingRegio;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.refreshingRegions.isPending = true;
              _this7.addingRegionSub.form.regionParent = {};
              _this7.addingRegionSub.form.regionSub = {};
              _this = _this7;
              (_this$refreshingRegio = _this.refreshingRegions.cancellationToken) === null || _this$refreshingRegio === void 0 || _this$refreshingRegio.cancel();
              _this.refreshingRegions.cancellationToken = axios.CancelToken.source();
              _context6.next = 8;
              return request("/v1/regions?variant=with-subregions", "get", null, true, "api", null, _this.refreshingRegions.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.refreshingRegions.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to refresh regions.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 8:
              response = _context6.sent;
              _this7.regions = _toConsumableArray(response.data.value.map(function (x) {
                x.displayName = "".concat(x.country.printable_name, " / ").concat(x.name, " (").concat(x.isSpiritRegion ? "spirits" : "wines", ")");
                return x;
              }));
              _this7.refreshingRegions.isPending = false;
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    updateProductTypes: function updateProductTypes() {
      this.producer.isWinery = this.productTypes.some(function (x) {
        return x == "wines";
      });
      this.producer.isDistillery = this.productTypes.some(function (x) {
        return x == "spirits";
      });
    },
    save: function save() {
      if (this.isAdding) {
        this.saveProducer("post");
      } else {
        this.saveProducer("put");
      }
    },
    saveProducer: function saveProducer(verb) {
      this.$EventBus.$emit("loading", true);
      var _this = this;
      _this.producer.alternativeStorageAddresses.forEach(function (x) {
        delete x.technical_front_id;
      });
      var data = _objectSpread(_objectSpread({}, _this.producer), _this.dbSupplierAssociated);
      if (!this.isAdding) {
        data.applyNewDefaultTastingPhotoRequired = this.applyNewDefaultTastingPhotoRequired;
      }
      request("/v1/producers/", verb, data, true, "api").then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(response) {
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (response.status == 201 || response.status == 200) {
                  _this.producer.id = response.data;
                  _this.skuManual = false;
                  _this.$nextTick(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          if (!(verb == "post")) {
                            _context7.next = 5;
                            break;
                          }
                          _context7.next = 3;
                          return _this.$refs.mainUploader.uploadAll();
                        case 3:
                          _context7.next = 5;
                          return _this.$refs.sliderUploader.uploadAll();
                        case 5:
                          _this.$toasted.show("Producer saved.", {
                            type: "success"
                          });
                          _this.$EventBus.$emit("loading", false);
                          _this.readOnly = true;
                          _this.$router.replace({
                            name: "adminProducerDetails",
                            params: {
                              id: _this.producer.id,
                              isWinery: _this.isWinery,
                              isDistillery: _this.isDistillery,
                              returnRoute: "adminProducerList"
                            }
                          });
                          _this.$router.go(_this.$router.currentRoute);
                        case 10:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7);
                  })));
                }
              case 1:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (e) {
        var errorData = getErrorData(e, _this.managedExceptions, null, true);
        handleErrorData(_this, errorData);
        _this.$EventBus.$emit("loading", false);
      });
    },
    checkSkuAcronymUnicity: function checkSkuAcronymUnicity() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this$checkingSkuAcro;
        var _this, dataForSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this8.checkingSkuAcronymUnicity.isPending = true;
              _this8.checkingSkuAcronymUnicity.result = null;
              _this = _this8;
              (_this$checkingSkuAcro = _this.checkingSkuAcronymUnicity.cancellationToken) === null || _this$checkingSkuAcro === void 0 || _this$checkingSkuAcro.cancel();
              _this.checkingSkuAcronymUnicity.cancellationToken = axios.CancelToken.source();
              dataForSearch = {
                skuAcronym: _this8.producer.skuAcronym
              };
              if (!_this8.isAdding) {
                dataForSearch.producerId = _this8.producer.id;
              }
              paramsQuery = Object.encodeToUri(dataForSearch);
              _context9.next = 10;
              return request("/v1/producers/sku-unicity?params=".concat(paramsQuery), "get", null, true, "api", null, _this.checkingSkuAcronymUnicity.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.checkingSkuAcronymUnicity.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to check sku unicity.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context9.sent;
              _this8.checkingSkuAcronymUnicity.result = response.data.value;
              _this8.checkingSkuAcronymUnicity.isPending = false;
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    openImageUrl: function openImageUrl(url) {
      window.open(url, "_blank");
    },
    updateUploaderStatus: function updateUploaderStatus(value) {
      this.isMainUploaderContainsFile = value;
    },
    uploadMain: function uploadMain() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this9.isMakingDrawerStateless = true;
              _this9.$EventBus.$emit("loading", true);
              _this9.$refs.mainUploader.uploadAll();
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    uploadSecondary: function uploadSecondary() {
      this.$refs.sliderUploader.uploadAll();
    },
    fetchImages: function fetchImages() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this = _this10;
              _this10.gettingImages.isPending = true;
              _context11.next = 4;
              return request("/v1/producers/".concat(_this10.producer.id, "/images"), "get", null, true, "api", null, _this10.filesCancelToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load images.");
                handleErrorData(_this, errorData);
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context11.sent;
              if (response.data.value.secondaryImg == "" || response.data.value.secondaryImg == null) {
                _this10.vfluxDefault = ["https://dfwa-prod-img.s3.amazonaws.com/assets/event-detail-img.jpg"];
              } else {
                _this10.producerImages.secondaryImg = response.data.value.secondaryImg;
              }
              if (response) _this10.producerImages.mainImg = response.data.value.mainImg;
              _this10.gettingImages.isPending = false;
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    removeMainImage: function removeMainImage(image) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this11.isMakingDrawerStateless = true;
              _context12.next = 3;
              return _this11.$refs.confirm.open("Cancel", "Are you sure you want to remove this image?", {
                color: "red"
              });
            case 3:
              confirmed = _context12.sent;
              if (!confirmed) {
                _context12.next = 8;
                break;
              }
              _this11.producerImages.mainImg = null;
              _context12.next = 8;
              return _this11.removeImage(image, imgDbType.MAIN.id);
            case 8:
              _this11.digestStatelessDrawer();
            case 9:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    removeSecondaryImage: function removeSecondaryImage(index, image) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this12.isMakingDrawerStateless = true;
              _context13.next = 3;
              return _this12.$refs.confirm.open("Cancel", "Are you sure you want to remove this image?", {
                color: "red"
              });
            case 3:
              confirmed = _context13.sent;
              if (confirmed) {
                _this12.producerImages.secondaryImg.splice(index, 1);
                _this12.removeImage(image, imgDbType.SECONDARY.id);
              }
              _this12.digestStatelessDrawer();
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    removeImage: function removeImage(image, type) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this13.isLoadingFiles = true;
              data = {
                path: image,
                type: type
              };
              _this = _this13;
              _context14.next = 5;
              return request("/v1/uploader/producers/".concat(_this13.producer.id, "/images"), "delete", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to remove this image");
                handleErrorData(_this, errorData);
                _this.isLoadingFiles = false;
                throw e;
              });
            case 5:
              _this13.isMakingDrawerStateless = false;
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    callToUpdate: function callToUpdate() {
      this.readOnly = false;
    },
    cancel: function cancel() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!_this14.producer.id) {
                _context15.next = 7;
                break;
              }
              _context15.next = 3;
              return _this14.getProducer();
            case 3:
              _this14.readOnly = true;
              _this14.skuManual = false;
              _context15.next = 8;
              break;
            case 7:
              window.history.back();
            case 8:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    deleteProducer: function deleteProducer(producerName) {
      var _this = this;
      _this.$refs.confirm.open("Delete", "Are you sure you want to delete the winery " + producerName + " ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          request("/v1/producers/" + _this.producer.id, "delete", null, true, "api").then(function (_) {
            _this.$router.push({
              name: "adminProducerList",
              params: _this.returnParams.params,
              query: _this.returnParams.query
            });
          }).catch(function (e) {
            var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete the winery", true);
            handleErrorData(_this, errorData);
          });
        }
      });
    },
    toggleSkuManual: function toggleSkuManual() {
      this.skuManual = !this.skuManual;
      if (!this.skuManual) {
        this.producer.skuAcronym = this.skuAcronymOriginal;
        this.checkingSkuAcronymUnicity.result = null;
      }
    },
    saveStorageAddresses: function saveStorageAddresses(addresses) {
      this.producer.alternativeStorageAddresses = _toConsumableArray(addresses);
    },
    openNewBeverageRegion: function openNewBeverageRegion() {
      this.addingRegionSub.isOpen = true;
    },
    cancelNewBeverageRegion: function cancelNewBeverageRegion() {
      this.addingRegionSub.isOpen = false;
    },
    addBeverageRegion: function addBeverageRegion() {
      var _this15 = this;
      if (!this.producer.regionSubs.some(function (x) {
        return x.id == _this15.addingRegionSub.form.regionSub.id;
      })) {
        this.addingRegionSub.form.regionSub = _objectSpread(_objectSpread({}, this.addingRegionSub.form.regionSub), {}, {
          regionParent: {
            name: this.addingRegionSub.form.regionParent.name,
            country: this.addingRegionSub.form.regionParent.country
          }
        });
        this.producer.regionSubs.push(this.addingRegionSub.form.regionSub);
      }
      this.addingRegionSub.form.regionParent = {};
      this.addingRegionSub.form.regionSub = {};
      this.addingRegionSub.isOpen = false;
    },
    removeBeverageRegion: function removeBeverageRegion(regionSub) {
      this.producer.regionSubs.splice(this.producer.regionSubs.indexOf(regionSub), 1);
    },
    closeWineStockListModal: function closeWineStockListModal() {
      var _this16 = this;
      this.$nextTick(function () {
        _this16.wineStockKey = null;
        _this16.currentWine = null;
        _this16.casingIdSelected = null;
        _this16.currentQuantity = 0;
      });
    },
    changeQuantityOrder: function changeQuantityOrder(_ref5) {
      var idWine = _ref5.idWine,
        quantity = _ref5.quantity;
      if (typeof this.quantityByWine.filter(function (q) {
        return q.id_wine === idWine;
      })[0] == "undefined") {
        // unknown reference for this session of shopping, we add it to the array
        this.quantityByWine.push({
          id_wine: idWine,
          quantity: quantity
        });
      } else {
        // Already add a value, so we update it
        var element = this.quantityByWine.filter(function (q) {
          return q.id_wine === idWine;
        })[0];
        element.quantity = quantity;
      }
    },
    addItemToCart: function addItemToCart(wine, casingId) {
      var _arguments = arguments,
        _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _wine$stocks;
        var isFromWineStockModal, quantityFromStockModal, quantity, element, casing, isBypassingReachedBuyLimit, _this, currentOrder, _this18, _this19, index;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              isFromWineStockModal = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : false;
              quantityFromStockModal = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 0;
              if (!(_this17.thirdPartyOrder && !orderHandler.getThirdPartyUserSelected())) {
                _context18.next = 5;
                break;
              }
              _this17.$toasted.show("You should choose a user before adding an item to your cart.", {
                type: "warning"
              });
              return _context18.abrupt("return");
            case 5:
              // We get the quantity set by the user, default 1
              quantity = 1;
              if (quantityFromStockModal > 0) {
                quantity = quantityFromStockModal;
                _this17.wineStockKey = null;
                _this17.currentWine = null;
                _this17.casingIdSelected = null;
                _this17.currentQuantity = 0;
              } else {
                element = _this17.quantityByWine.filter(function (q) {
                  return q.id_wine === wine.id_wine;
                })[0];
                if (element) {
                  // otherwise we set the item with the quantity typed
                  quantity = element.quantity;
                }
              }
              if (!(!isFromWineStockModal && isAdminNotConsultant(_this17.loggedUserData) && ((_wine$stocks = wine.stocks) === null || _wine$stocks === void 0 ? void 0 : _wine$stocks.length) >= 1)) {
                _context18.next = 15;
                break;
              }
              _this17.wineStockKey = wine.id_wine;
              _this17.currentWine = wine;
              _this17.casingIdSelected = casingId;
              _this17.currentQuantity = parseInt(quantity);
              _this17.$nextTick(function () {
                _this17.$refs.WineStockListModal.open();
              });
              _context18.next = 35;
              break;
            case 15:
              _this17.isAddingToCart = [].concat(_toConsumableArray(_this17.isAddingToCart), [wine.id_wine]);

              // Perform casing adjustment
              casing = +casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              isBypassingReachedBuyLimit = null;
              _this = _this17;
              _context18.next = 22;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this17.$toasted, _this17).catch(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e) {
                  var _e$value;
                  var _e$value$errorMessage, _e$value2, _e$value3, errorMessage;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        _this.isAddingToCart = _toConsumableArray(_this.isAddingToCart.filter(function (x) {
                          return x !== wine.id_wine;
                        }));
                        if (!((e === null || e === void 0 || (_e$value = e.value) === null || _e$value === void 0 ? void 0 : _e$value.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                          _context16.next = 7;
                          break;
                        }
                        _this.$toasted.clear();
                        errorMessage = (_e$value$errorMessage = e === null || e === void 0 || (_e$value2 = e.value) === null || _e$value2 === void 0 ? void 0 : _e$value2.errorMessage) !== null && _e$value$errorMessage !== void 0 ? _e$value$errorMessage : e === null || e === void 0 || (_e$value3 = e.value) === null || _e$value3 === void 0 ? void 0 : _e$value3.message;
                        _context16.next = 6;
                        return _this.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                          color: "red"
                        });
                      case 6:
                        isBypassingReachedBuyLimit = _context16.sent;
                      case 7:
                        return _context16.abrupt("return");
                      case 8:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x2) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 22:
              if (!isBypassingReachedBuyLimit) {
                _context18.next = 33;
                break;
              }
              currentOrder = orderHandler.getCurrentOrder();
              if (!currentOrder) {
                _context18.next = 30;
                break;
              }
              _this18 = _this17;
              _context18.next = 28;
              return request("/v1/order/".concat(orderHandler.getCurrentOrder().id_order, "/bypass"), "put", null, true, "api").then(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_) {
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.next = 2;
                        return orderHandler.addItemToCart(wine, quantity, casingId, _this18.$toasted, _this18, true).catch(function () {
                          _this18.isAddingToCart = _toConsumableArray(_this18.isAddingToCart.filter(function (x) {
                            return x !== wine.id_wine;
                          }));
                        });
                      case 2:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17);
                }));
                return function (_x3) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 28:
              _context18.next = 33;
              break;
            case 30:
              _this19 = _this17;
              _context18.next = 33;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this17.$toasted, _this17, true).catch(function () {
                _this19.isAddingToCart = _toConsumableArray(_this19.isAddingToCart.filter(function (x) {
                  return x !== wine.id_wine;
                }));
              });
            case 33:
              index = _this17.isAddingToCart.indexOf(wine.id_wine);
              _this17.isAddingToCart.splice(index, 1);
            case 35:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    toggleFavorite: function toggleFavorite(wine) {
      wine.favorite = !wine.favorite;
      var _this = this;
      // Save the order serverside before saving it in the local storage
      request("/v1/user/favorites/" + wine.id_wine + "?isWineToAdd=" + wine.favorite, "put", null, true, "api").then(function () {
        if (wine.favorite) {
          _this.$toasted.show("Product added to your favorites.", {
            type: "success"
          });
        } else {
          _this.$toasted.show("Product removed from your favorites.", {
            type: "success"
          });
        }
      });
    },
    openAttachedFilesDrawer: function openAttachedFilesDrawer() {
      this.$refs.producerAttachedFileDrawerRef.openDrawer();
    },
    toRegions: function toRegions() {
      return {
        name: "adminRegionList"
      };
    },
    isHolding: isHolding,
    isUserBuyerGroup: isUserBuyerGroup,
    isAdminNotConsultant: isAdminNotConsultant
  }
};